var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M21.2602 7.14755L12.8552 2.29492L4.4502 7.14755V16.8528L12.8552 21.7054L21.2602 16.8528V7.14755ZM19.7602 7.43623L12.8552 3.44962L5.9502 7.43623L12.8552 11.4228L19.7602 7.43623ZM12.3552 12.2889L5.4502 8.30225V16.2755L12.3552 20.2621V12.2889ZM13.3552 20.2621V12.2889L20.2602 8.30225V16.2755L13.3552 20.2621Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
